import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import {
	ClientDocumentsItems,
	ClientDocumentsParams,
	DocumentsToDownload,
	DownloadDocumentsParams,
	RequestDocumentPayload,
	RequestDocumentToClientsPayload,
	RequestDownload,
	SendDocumentPayload,
} from '@/interfaces';

class CaseDocumentsService {
	constructor(private client: AxiosInstance) {}

	async getListDocuments(
		props: ClientDocumentsParams
	): Promise<HttpResponse<ClientDocumentsItems>> {
		const {
			case_id,
			page,
			// limit,
			search,
			client_status,
			document_status,
			document_types,
			client_id,
			received_start_date,
			received_end_date,
			sent_start_date,
			sent_end_date,
		} = props;

		const documentsType = document_types?.split(',').includes('SETTLEMENT')
			? document_types
					?.split(',')
					?.filter((key) => key !== 'SETTLEMENT')
					?.concat('SETTLEMENT_WITH_SIGN', 'SETTLEMENT_WITHOUT_SIGN')
			: document_types?.split(',');

		const params = {
			page,
			// limit,
			...(client_id && { user_id: client_id }),
			...(search && { search }),
			...(client_status && { client_status: client_status.split(',') }),
			...(document_status && { document_status: document_status.split(',') }),
			...(document_types && { document_types: documentsType }),
			...(received_start_date && { received_start_date }),
			...(received_end_date && { received_end_date }),
			...(sent_start_date && { sent_start_date }),
			...(sent_end_date && { sent_end_date }),
		};
		return this.client.get(`/case-documents/${case_id}`, { params });
	}

	async getDocumentsToDownload(
		case_id: string,
		body: DownloadDocumentsParams
	): Promise<HttpResponse<DocumentsToDownload[]>> {
		return this.client.post(`/case-documents/${case_id}`, { ...body });
	}

	async downloadDocuments(request: RequestDownload): Promise<{
		message: string;
		downloadUrl: string;
		filename: string;
		zipSizeMB: string;
		filesProcessed: number;
		expiresInSeconds: number;
	}> {
		const response = await fetch(
			'https://ufefgeesc6.execute-api.us-east-1.amazonaws.com/dev/zip-documents',
			{
				method: 'POST',
				body: JSON.stringify(request),
			}
		);
		return response.json();
	}

	async postSendDocument(
		data: SendDocumentPayload
	): Promise<HttpResponse<{ message: string }>> {
		return this.client.post(`/action-required/send-document-to-clients`, data);
	}

	async postRequestDocument(
		data: RequestDocumentToClientsPayload
	): Promise<HttpResponse<{ message: string }>> {
		return this.client.post(
			`/action-required/request-document-to-clients`,
			data
		);
	}

	async requestDocumentCriteria(
		id: string,
		payload: RequestDocumentPayload
	): Promise<HttpResponse<any>> {
		return this.client.put(
			`/cases-applicant/documents-required/${id}/criteria`,
			{ payload }
		);
	}
}

export const caseDocumentsService = new CaseDocumentsService(axiosClient);
